import React from 'react';
import DataTable from 'common/components/DataTable';
import Spinner from 'common/components/Spinner';
import ButtonExportToExcel from "../ButtonExportToExcel";
import {useTabSavedRowsContext} from "./TabSavedRowsContext";
import {
  commonColumns,
  surveyAssetsColumns,
  taxAuthorityColumns
} from '../../../../common/constants/gridColumns';
import styles from './styles.module.scss';

const TabSavedRows = ({
                        step9ChangeTab1ColumnVisibility,
                        step9ChangeTab2ColumnVisibility,
                        step9ChangeTab3ColumnVisibility,
                        step9ChangeTab4ColumnVisibility,
                        customClassNames,
                        allowInspectionsShare,
                        ...rest
                      }) => {

  const {
    preparedGridTaxAuthority,
    totalPagesTaxAuthority,
    taxAuthorityPage,
    setTaxAuthorityPage,
    totalResultCountTaxAuthority,
    sortColumnNameTax,
    sortDirectionTax,
    handleSortChangeTax,

    preparedGridFirm,
    totalPagesFirm,
    firmPage,
    setFirmPage,
    totalResultCountFirm,
    sortColumnNameFirm,
    sortDirectionFirm,
    handleSortChangeFirm,

    preparedGridShared,
    totalPagesShared,
    sharedPage,
    setSharedPage,
    totalResultCountShared,
    sortColumnNameShared,
    sortDirectionShared,
    handleSortChangeShared,

    preparedGridSurveyAssets,
    totalPagesSurveyAssets,
    totalResultCountSurveyAssets,
    setSurveyAssetsPage,
    surveyAssetsPage,
    sortColumnNameSurveyAssets,
    sortDirectionSurveyAssets,
    handleSortChangeSurveyAssets,

    handleGetExcel,
    loading
  } = useTabSavedRowsContext();

  const handleColumnChange = handler => async (...args) => {
    try {
      await handler(...args);
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className={styles.tabSavedRowsContainer}>
      <div className={styles.buttonsContainer}>
        {loading
          ? <Spinner customClassNames={styles.spinnerContainer}/>
          : <div className={styles.spinnerContainer}/>
        }
        <ButtonExportToExcel onClick={handleGetExcel}/>
      </div>
      <div>
        <h2 className={customClassNames.savedRowsTableHeader}>רשות המיסים</h2>
        <DataTable
          columnsList={taxAuthorityColumns}
          data={preparedGridTaxAuthority}
          customClassNames={customClassNames}
          columnStorageKey={'gridTaxAuthorityColumns'}
          onColumnChange={handleColumnChange(step9ChangeTab1ColumnVisibility)}
          allowSorting={true}
          sortColumnName={sortColumnNameTax}
          sortDirection={sortDirectionTax}
          onSortChange={handleSortChangeTax}
          page={taxAuthorityPage}
          setPage={setTaxAuthorityPage}
          totalPages={totalPagesTaxAuthority}
          totalResultCount={totalResultCountTaxAuthority}
          {...rest}
        />
      </div>
      <div>
        <h2 className={customClassNames.savedRowsTableHeader}>מאגר דוחות המשרד</h2>
        <DataTable
          columnsList={commonColumns}
          data={preparedGridFirm}
          customClassNames={customClassNames}
          columnStorageKey={'gridFirmColumns'}
          onColumnChange={handleColumnChange(step9ChangeTab2ColumnVisibility)}
          allowSorting={true}
          sortColumnName={sortColumnNameFirm}
          sortDirection={sortDirectionFirm}
          onSortChange={handleSortChangeFirm}
          page={firmPage}
          setPage={setFirmPage}
          totalPages={totalPagesFirm}
          totalResultCount={totalResultCountFirm}
          {...rest}
        />
      </div>
      {allowInspectionsShare && (
        <div>
          <h2 className={customClassNames.savedRowsTableHeader}>מאגר דוחות שיתופי</h2>
          <DataTable
            columnsList={commonColumns}
            data={preparedGridShared}
            customClassNames={customClassNames}
            columnStorageKey={'gridSharedColumns'}
            onColumnChange={handleColumnChange(step9ChangeTab3ColumnVisibility)}
            allowSorting={true}
            sortColumnName={sortColumnNameShared}
            sortDirection={sortDirectionShared}
            onSortChange={handleSortChangeShared}
            page={sharedPage}
            setPage={setSharedPage}
            totalPages={totalPagesShared}
            totalResultCount={totalResultCountShared}
            {...rest}
          />
        </div>
      )}
      <div>
        <h2 className={customClassNames.savedRowsTableHeader}>סקר נתוני היצע</h2>
        <DataTable
          columnsList={surveyAssetsColumns}
          data={preparedGridSurveyAssets}
          customClassNames={customClassNames}
          columnStorageKey={'gridSurveyAssetsColumns'}
          onColumnChange={handleColumnChange(step9ChangeTab4ColumnVisibility)}
          allowSorting={true}
          sortColumnName={sortColumnNameSurveyAssets}
          sortDirection={sortDirectionSurveyAssets}
          onSortChange={handleSortChangeSurveyAssets}
          page={surveyAssetsPage}
          setPage={setSurveyAssetsPage}
          totalPages={totalPagesSurveyAssets}
          totalResultCount={totalResultCountSurveyAssets}
          {...rest}
        />
      </div>
    </div>
  );
};

export default TabSavedRows;